module.exports = __webpack_public_path__ + "static/media/reports_active.68abf7a9.svg";